// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { FolderPlus } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconFolderPlus(props: any) {
    return <IconBase icon={FolderPlus} {...props} />
  }

  export default IconFolderPlus
  